// @flow
import React from "react"
import { compose, withStateHandlers, type HOC } from "recompose"
import withRouter from "hoc/withRouter"
import { minHeightImg, selectIndexImage } from "data/images/helpers"
import type { InventoryProduct } from "data/product/types"
import { Text } from "componentsStyled/Typography/Texts"
import { SubTitle } from "componentsStyled/Typography/Titles"
import {
  ProductTileWrap,
  ProductModels,
  ImageWrap,
  Body,
  Option,
} from "./styled"
import Checkbox from "components/Checkbox"
import type { ProductVariant } from "data/product/types"
import type { ID } from "data/enums/types"

/**
 * Render a product tile that contains variants shown on selection
 */
const ProductInventoryTile = ({
  product,
  handleClick,
  selected,
  selectVariant,
  variants,
}) => {
  const indexImage = selectIndexImage(product.images)
  const imageSize = minHeightImg(indexImage, 250)
  const itemSelected =
    selected || variants.filter(variant => variant.selected).length > 0

  return (
    <ProductTileWrap onClick={handleClick} selected={itemSelected}>
      <ImageWrap>
        <img src={imageSize.url} alt={indexImage.alt} draggable="false" />
      </ImageWrap>
      <Body>
        <SubTitle>{product.name}</SubTitle>
      </Body>
      <ProductModels selected={itemSelected}>
        <Text bold uppercase white>
          {product.name}
        </Text>
        <Text bold uppercase white>
          Product Models
        </Text>
        <Text white verySmall> Select the Model and Size that you have in Stock </Text>
        {variants.map(variant => {
          return (
            <Option key={variant.id} onClick={() => selectVariant(variant)}>
              <Checkbox value={variant.selected} />
              <Text verySmall medium white>
                {variant.name}
              </Text>
            </Option>
          )
        })}
      </ProductModels>
    </ProductTileWrap>
  )
}

type Outter = {|
  product: InventoryProduct,
  activeProducts: ProductVariant[],
  selectProduct: ({ id: ID, name: string, productGroupId: number }) => void,
|}

const enhancer: HOC<*, Outter> = compose(
  withRouter,
  withStateHandlers(
    props => ({
      selected: false,
      variants: fetchVariants(props.product, props.activeProducts),
    }),
    {
      handleClick: props => product => {
        return {
          selected: true,
        }
      },
      selectVariant: (state, props) => selectedVariant => {
        //HACK(HARRY) remove the selected key for obj passed to backend
        let variantToReturn = {
          id: selectedVariant.id,
          name: selectedVariant.name,
          productGroupId: selectedVariant.productGroupId,
        }
        //TODO(HARRY) this is slow, check the stack and determine why this is taking
        // so long
        props.selectProduct(variantToReturn)

        // For the list of variants, set 'selected' on the chosen variant
        const variants = Array.from(state.variants)
        variants.map(variant => {
          if (variant.id === selectedVariant.id) {
            return (variant.selected = variant.selected ? false : true)
          }
          return undefined
        })
        return {
          variants: variants,
        }
      },
    },
  ),
)

/**
 * Creates a list of variant choices for a Product
 */
const fetchVariants = (
  product: InventoryProduct,
  activeProducts: ProductVariant[],
) => {
  const variantOptions = product.variants.map(variant => ({
    id: variant.id,
    name: variant.name,
    productGroupId: product.productGroup.id,
    selected: hasSelection(variant, activeProducts).length > 0,
  }))
  return variantOptions
}

/**
 * Finds the intersection of variants
 * between the list of actively chosen Product Variants and the Product Variant
 */
const hasSelection = (
  variant: ProductVariant,
  activeProductVariants: ProductVariant[],
) => {
  return (
    activeProductVariants &&
    activeProductVariants.filter(activeProduct => activeProduct.id === variant.id)
  )
}

export default enhancer(ProductInventoryTile)



// WEBPACK FOOTER //
// ./src/pages/AffiliateRegistration/InventorySelector/ProductInventory/ProductInventoryTile/index.js